// @ts-nocheck
export function replaceAllNotDigitsTextCursor(value, cursorPosition) {
	const isCursorOnLasted = value.length === cursorPosition;

	if (isCursorOnLasted) {
		const formatedValue = value.replace(/[^\d]/g, '');
		return { newValue: formatedValue, newCursorPosition: formatedValue.length };
	}

	const firstPart = value.substring(0, cursorPosition);
	const secondPart = value.substring(cursorPosition);

	const formatedFirstPart = firstPart.replace(/[^\d]/g, '');
	const formatedSecondPart = secondPart.replace(/[^\d]/g, '');

	const formatedValue = formatedFirstPart + formatedSecondPart;
	const formatedCursorPosition = formatedFirstPart.length;

	return { newValue: formatedValue, newCursorPosition: formatedCursorPosition };
}

export function replaceAllNotHexadecimalTextCursor(value, cursorPosition) {
	const isCursorOnLasted = value.length === cursorPosition;

	if (isCursorOnLasted) {
		const formatedValue = value.replace(/[^0-9a-fA-F:]/g, '');
		return { newValue: formatedValue, newCursorPosition: formatedValue.length };
	}

	const firstPart = value.substring(0, cursorPosition);
	const secondPart = value.substring(cursorPosition);

	const formatedFirstPart = firstPart.replace(/[^0-9a-fA-F:]/g, '');
	const formatedSecondPart = secondPart.replace(/[^0-9a-fA-F:]/g, '');

	const formatedValue = formatedFirstPart + formatedSecondPart;
	const formatedCursorPosition = formatedFirstPart.length;
	return { newValue: formatedValue, newCursorPosition: formatedCursorPosition };
}

export function replaceAllNotAlphanumericTextCursor(value, cursorPosition) {
	const isCursorOnLasted = value.length === cursorPosition;

	if (isCursorOnLasted) {
		const formatedValue = value.replace(/[^A-Z0-9]/g, '');
		return { newValue: formatedValue, newCursorPosition: formatedValue.length };
	}

	const firstPart = value.substring(0, cursorPosition);
	const secondPart = value.substring(cursorPosition);

	const formatedFirstPart = firstPart.replace(/[^A-Z0-9]/g, '');
	const formatedSecondPart = secondPart.replace(/[^A-Z0-9]/g, '');

	const formatedValue = formatedFirstPart + formatedSecondPart;
	const formatedCursorPosition = formatedFirstPart.length;
	return { newValue: formatedValue, newCursorPosition: formatedCursorPosition };
}
